import React, { useState, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import ModalMuestra from './Modales/ModalMuestra';
import { subtareasContext } from './Subtareas';
import { Oval } from 'react-loader-spinner'
import "./MuestrasPA.scss"
import IcoListMuestra from "../assets/img/ico-list.svg"
import { jwtDecode } from "jwt-decode"

const API_URL = process.env.REACT_APP_API_URL;

export const muestrasContext = React.createContext();

function Muestras() {

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(auth)
    const user = jwtParse.apirest.objeto

    const {
        muestras,
        setMuestras,
        loadingMuestra,
        setLoadingMuestra,
        errorMuestra,
        setErrorMuestra,
        idSubtask,
        setIdSubtask,
        fetchMuestrasById,
    } = useContext(subtareasContext);

    const [idMuestra, setIdMuestra] = useState(null)
    const [modalMuestra, setModalMuestra] = useState(false)
    const [objMuestra, setObjMuestra] = useState(null)

    const [modalDeleteMuestra, setModalDeleteMuestra] = useState(false)
    const [errorDel, setErrorDel] = useState(null)

    // CREAR MUESTRA
    const handleNewMuestra = (e) => {
        e.preventDefault()
        setModalMuestra(true)
    }

    // EDITAR MUESTRA
    const handleEditMuestra = (id) => {
        const obj = muestras.find((e) => e.id_muestra === id)
        setObjMuestra(obj)
        setModalMuestra(true)
    }

    // DELETE MUESTRA
    const closeDeleteMuestra = () => {
        setModalDeleteMuestra(false)
        setErrorDel(null)
        setIdMuestra(null)
    }

    const handleModalDelete = (id) => {
        setIdMuestra(id)
        setModalDeleteMuestra(true)
    }

    const handleDeleteMuestra = async () => {
        const obj = {
            user,
            idMuestra: parseInt(idMuestra)
        }
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/planAccion/eliminarMuestra`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(obj)
            })
            const data = await res.json()
            const errorCode = data.error ?? data.status
            if(errorCode !== 0){
                setErrorDel(data.errorDetalle || data.codeError)
            } else {
                closeDeleteMuestra()
                // actualiza muestras
                setLoadingMuestra(true)
                fetchMuestrasById(idSubtask)
                .then(res => {
                    if(res.error !== 0){
                        setLoadingMuestra(false)
                        setErrorMuestra(res.errorDetalle)
                    } else {
                        setLoadingMuestra(false)
                        setMuestras(res.objeto)
                    }
                })
            }
        } catch (error) {
            setErrorDel("Error: Conexión con backend.")
        }
    }

    return (
        <muestrasContext.Provider value={{ user, idSubtask, setIdSubtask, setLoadingMuestra, fetchMuestrasById, setErrorMuestra, setMuestras, objMuestra, setObjMuestra }}>
            <ModalMuestra show={modalMuestra} onHide={() => setModalMuestra(false)} />
            {/* Modal Eliminar muestra */}
            <Modal className='modal__delete' show={modalDeleteMuestra} onHide={closeDeleteMuestra} backdrop="static" centered animation={false} >
                <Modal.Header closeButton>
                <Modal.Title><h3>Eliminar muestra</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Está seguro de eliminar esta muestra?</Modal.Body>
                <Modal.Footer className='d-flex flex-column'>
                <div className='d-flex flex-row align-items-center align-self-end'>
                    <button className='btn btn-secondary rounded-pill me-2' onClick={closeDeleteMuestra}>Cancelar</button>
                    <button className='btn btn-danger rounded-pill' onClick={handleDeleteMuestra}>Borrar</button>
                </div>
                {errorDel && <p>{errorDel}</p>}
                </Modal.Footer>
            </Modal>
            <div className='muestrasPA'>
            {loadingMuestra ? (
                <div className='loading__muestras d-flex flex-row align-items-center'>
                    <div className='me-2'>
                        <Oval
                            visible={true}
                            height="20"
                            width="20"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                    </div>
                    <p className='fw-medium m-0'>Loading...</p>
                </div>
            ) : (
                <>
                    {errorMuestra ? (
                        <div className='muestrasPA--error d-flex flex-column align-items-center'>
                            <p className='text-danger fw-medium'><i className="bi bi-exclamation-circle me-1"></i> {errorMuestra}</p>
                        </div>
                    ) : (
                        <>
                            {muestras.length === 0 ? (
                                <div className='muestrasPA--empty d-flex flex-row'>
                                    <div className='icon__lista__muestraPA d-flex justify-content-end'>
                                        <img src={IcoListMuestra} alt=''/>
                                    </div>
                                    <div className='muestrasPA--empty__btnadd d-flex flex-column'>
                                        <button onClick={handleNewMuestra} className='btn__addMuestra btn btn-outline-success btn-sm rounded-pill px-3 mb-2 fw-medium'><i className="bi bi-plus me-1"></i>Adjuntar archivo</button>
                                    </div>
                                </div>
                            ) : (
                                <div className='muestrasPA__container'>
                                    {muestras.map((m, i) => (
                                        <div key={i} className='eachMuestraPA d-flex flex-row align-items-center'>
                                            <div className='icon__lista__muestraPA d-flex justify-content-end'>
                                                <img src={IcoListMuestra} alt=''/>
                                            </div>
                                            <button onClick={()=>handleEditMuestra(m.id_muestra)} className='btn__edit d-flex flex-column align-items-center justify-content-center btn bg-success rounded-circle text-white'>
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                            <button onClick={()=>handleModalDelete(m.id_muestra)} className='btn__delete d-flex flex-column align-items-center justify-content-center btn bg-danger rounded-circle text-white'>
                                                <i className="bi bi-trash"></i>
                                            </button>
                                            {/* ICONO */}
                                            {(m.tipo === 1) && <i className="btn__type bi bi-file-earmark-text text-primary"></i>}
                                            {/* TIPO DE MUESTRA */}
                                            {(m.tipo === 1) && <div className=''><a className='' href={`${API_URL}/archivos/${m.descripcion}`} target='_blank' rel="noreferrer">{m.descripcion}</a></div>}
                                            {/* TIPO DE ESTADO */}
                                            {m.estado === 1 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-blue-700"><span>Subido</span></div>}
                                            {m.estado === 2 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-warning"><span>En revisión</span></div>}
                                            {m.estado === 3 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-success"><span>Aprobado</span></div>}
                                            {m.estado === 4 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-danger"><span>Rechazado</span></div>}
                                            {m.estado === 5 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-purple-600"><span>Reenviado</span></div>}
                                            {m.estado === 6 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-dark"><span>Eliminado</span></div>}
                                            {/* FECHA DE CREACIÓN */}
                                            <p className='m-0'>{(m.fecha_creacion.slice(0,10)).replace(/-/g, '/').split("/").reverse().join("/")}</p>
                                        </div>
                                    ))}
                                    <div className='muestrasPA--empty d-flex flex-row'>
                                        <div className='icon__lista__muestraPA d-flex justify-content-end'>
                                            <img src={IcoListMuestra} alt=''/>
                                        </div>
                                        <div className='muestrasPA--empty__btnadd d-flex flex-column'>
                                            <button onClick={handleNewMuestra} className='btn__addMuestra btn btn-outline-success btn-sm rounded-pill px-3 mb-2 fw-medium'><i className="bi bi-plus me-1"></i>Adjuntar archivo</button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
            </div>
        </muestrasContext.Provider>
    )
}

export default Muestras